module Arkadium.Game
{
    "use strict"
    import Signal = Factive.Core.Signal.Signal;
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import EventBusConstants = Factive.Core.EventBusConstants;
    import EventBus = Factive.Core.EventBus;

    export class ArenaHelper
    {
        private _eventBus:EventBus;
        private _pauseHandler:any;
        private _resumeHandler:any;
        private _arenaXapi:any;
        private _dc: Factive.Core.DependenciesContainer;

        public testActionCallback:any;

        constructor(dc:DependenciesContainer)
        {
            this._dc = dc;
            if(window["ArenaXApi"]!= undefined && window["ArenaXApi"] !=null) {
				this._arenaXapi = window["ArenaXApi"].getInstance();
			}
            this.testActionCallback = null;
            this._eventBus = this._dc.get("EventBus");

            this._pauseHandler = () => { this.handleMidrollStart(); };
            this._resumeHandler = () => { this.handleMidrollFinish(); };

            if (this._arenaXapi)
            {
                this._arenaXapi.addAction('GAME_PAUSE', this._pauseHandler);
                this._arenaXapi.addAction('GAME_RESUME', this._resumeHandler);
            }
            else
            {
                window["ARK_game_arena_connector"].init();
                window["ARK_game_arena_connector"].registerAction("pause", this._pauseHandler);
                window["ARK_game_arena_connector"].registerAction("resume", this._resumeHandler);
            }
        };

        // ========================= Methods =========================
        public sendMidrollRequest()
        {
            //console.log("[ArenaHelper] handleMidrollRequest");
            if (this._arenaXapi)
            {
                this._arenaXapi.dispatch({type: 'PAUSE_READY', payload: null});
            }
            else
            {
                window["ARK_game_arena_connector"].fireEventToArena("pause_ready");
            }
        };

        public handleMidrollStart()
        {
            this._eventBus.dispatch(Factive.Core.EventBusConstants.GAMEPLAY_MIDROLL_STARTED,Factive.Core.EventBusConstants.GAMEPLAY);
        };

        public handleMidrollFinish()
        {
            this._eventBus.dispatch(Factive.Core.EventBusConstants.GAMEPLAY_MIDROLL_FINISHED,Factive.Core.EventBusConstants.GAMEPLAY);
        };

        public sendEventChange()
        {
            //console.log("[ArenaHelper] handleEventChange");
            if (this._arenaXapi)
            {
                this._arenaXapi.dispatch({type: 'EVENT_CHANGE', payload: null})
            }
            else
            {
                window["ARK_game_arena_connector"].fireEventToArena("event_change");
            }
        };

        public sendGameStart()
        {
            //console.log("[ArenaHelper] handleGameStart");
            if (this._arenaXapi)
            {
                this._arenaXapi.dispatch({type: 'GAME_START', payload: null});
            }
            else
            {
                window["ARK_game_arena_connector"].fireEventToArena("game_start");
            }
        };

        public changeScore(score:number):void
        {
            if(window["ARK_game_arena_connector"] )
            {
                window["ARK_game_arena_connector"].changeScore(score);
            }
        };

        public sendGameEnd(score)
        {
            //console.log("[ArenaHelper] handleGameEnd");
            if (this._arenaXapi)
            {
                this._arenaXapi.dispatch({type: 'CHANGE_SCORE', payload: score});
                this._arenaXapi.dispatch({type: 'GAME_END', payload: null});
            }
            else
            {
                let showArenaGameEnd:boolean = window["ARK_game_arena_connector"].showGameEnd() == false;
                if(showArenaGameEnd)
                {
                    window["ARK_game_arena_connector"].changeScore(score);
                    window["ARK_game_arena_connector"].fireEventToArena('game_end');
                }
            }
        };

        public shouldShowInternalGameEnd():boolean
        {
            if (this._arenaXapi)
            {
                return false;
            }

            let showGameEnd:any = window["ARK_game_arena_connector"].showGameEnd();
            let showInternalGameEnd:boolean = (showGameEnd == true);
            return showInternalGameEnd;
        };

        public getAbsoluteURL(relativeUrl:string):string
        {
            if(this._arenaXapi)
            {
                return [this._arenaXapi.assetOriginUrl, relativeUrl].join('');
            }
            return relativeUrl;

        }

        gup ( name, url = null ) {
            if (!url) url = location.href;
            name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
            var regexS = "[\\?&]"+name+"=([^&#]*)";
            var regex = new RegExp( regexS );
            var results = regex.exec( url );
            return results == null ? null : results[1];
        };

        public getLocale():string
        {
            let supportLanguages =[
                { "value": "en", "localization":"en-US", "name": "English" }
                ,{ "value": "de", "localization":"de-DE", "name": "Deutsch" }
                ,{ "value": "es", "localization":"es-ES", "name": "Español" }
                ,{ "value": "fr", "localization":"fr-FR", "name": "Français" }
                ,{ "value": "it", "localization":"it-IT", "name": "Italiano" }

                //,{ "value": "pt", "name": "Português" }
                //,{ "value": "ja", "text": "Japan" }
                //,{ "value": "ru", "text": "Русский" }
                //,{ "value": "pl", "text": "Polski" }
            ];

            let lang = "en-US";
            if (this._arenaXapi)
            {
                lang = this._arenaXapi.locale;
            }
            else
            {
                lang = window["ARK_game_arena_connector"].getParam("locale", "en-US");
            }

            lang = lang.split("-")[0];
            let localization ="en-US";
            for (let i=0;i<supportLanguages.length;i++){
                if(supportLanguages[i].value == (this.gup('ark-lang') || lang)){
                    localization = supportLanguages[i].localization;
                    break;
                }
            }

            return localization;
        }

        public handleCustomEvent(eventName, dataString)
        {
            //console.log("[ArenaHelper] handleCustomEvent");
            if (this._arenaXapi) {
                return;
            }
            else {
                window["ARK_game_arena_connector"].fireEventToArena(eventName, dataString);
            }
        };

        public initTestingEnvironment()
        {
            if (this._arenaXapi)
            {
                this._arenaXapi.addAction("TEST_ACTION", this.processTestAction.bind(this));
                this._arenaXapi.dispatch({type: "TEST_READY", payload: null});
                return;
            }
            else
            {
                window["ARK_game_arena_connector"].registerAction("test_action", this.processTestAction.bind(this));
                window["ARK_game_arena_connector"].initTestingEnvironment();
            }
        }

        private processTestAction(params)
        {
            for (var i = 0; i < params.length; i++) {
                var obj = params[i];
                if (obj.name == "test_object")
                {
                    var testingParams = obj.value.split(";");
                    var testing_action=testingParams[0];
                    if (this.testActionCallback)
                    {
                        this.testActionCallback(testing_action)
                    }
                    break;
                }
            }
        }

        // ========================= Destruction =========================
        public destroy()
        {
            if (this._arenaXapi)
            {
                this._arenaXapi.removeAction('GAME_PAUSE');
                this._arenaXapi.removeAction('GAME_RESUME');
                this._arenaXapi.removeAction('TEST_ACTION');
            }

        };
    }
}





// WEBPACK FOOTER //
// src/typescript/Core/Arena/ArenaHelper.ts